export default __webpack_public_path__ + "static/media/O365_1.5f914c69.png";